export default "__VITE_ASSET__CVB8wGSo__"